import { render, staticRenderFns } from "./PromotionStepDisplaying.vue?vue&type=template&id=0b4c981d&scoped=true&"
import script from "./PromotionStepDisplaying.vue?vue&type=script&lang=js&"
export * from "./PromotionStepDisplaying.vue?vue&type=script&lang=js&"
import style0 from "./PromotionStepDisplaying.vue?vue&type=style&index=0&id=0b4c981d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c981d",
  null
  
)

export default component.exports